





































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class Pagination extends Vue {
  @Prop() readonly amountPage!: number;

  @Prop() readonly currentPage!: number;

  @Prop() readonly changePage!: Function;

  visibleButton: Array<number> = [];

  inputPage = 0;

  isShowBtn = false;

  @Watch('currentPage', { immediate: true, deep: true })
  changeInputPage() {
    this.inputPage = this.currentPage;
  }

  @Watch('inputPage', { immediate: true, deep: true })
  disableButton() {
    if (this.amountPage >= this.inputPage && this.inputPage > 0) {
      this.isShowBtn = false;
    } else {
      this.isShowBtn = true;
    }
  }

  beforeUpdate() {
    this.rendenPage();
  }

  rendenPage() {
    this.visibleButton = [];
    const pageList = Array.from(Array(this.amountPage), (_, i) => i + 1);
    const idx = pageList.findIndex((i) => i === this.currentPage);
    const left = pageList.slice(idx - 3 < 0 ? 0 : idx - 2, idx);
    const right = pageList.slice(idx, idx + 3 > pageList.length ? pageList.length : idx + 3);
    this.visibleButton = [...left, ...right];
  }

  colorBtn(i) {
    return i === this.currentPage ? '' : 'white';
  }
}
